/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
const Occupations = [
  { value: '公務員', label: 'Public Official 公務員' },
  { value: '経営者・役員', label: 'Manager / Officer 経営者・役員' },
  { value: '会社員', label: 'Employee 会社員' },
  { value: '自営業', label: 'Self-employed 自営業' },
  { value: '自由業', label: 'Freelance profession 自由業' },
  { value: '専業主婦（夫）', label: 'Housewife (husband) 専業主婦（夫）' },
  { value: 'パート・アルバイト', label: 'Part-time worker パート・アルバイト' },
  { value: '学生', label: 'Student 学生' },
  { value: 'その他', label: 'Other その他' }
]

export default Occupations
